import React from 'react'

const ClockCircle = ({ color, size }) => {
  return (
    <svg
      width={size || '16'}
      height={size || '16'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        stroke={color || '#D4A418'}
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default ClockCircle
